import type { ReactNode } from 'react';

type ApprenantFormFieldProps = {
  label: string;
  htmlFor?: string;
  hint?: string;
  className?: string;
  children: ReactNode;
};

export default function ApprenantFormField({
  label,
  htmlFor,
  hint,
  className = '',
  children,
}: ApprenantFormFieldProps) {
  return (
    <label className={`apprenant-form-field ${className}`.trim()} htmlFor={htmlFor}>
      <span className="apprenant-form-field__label">{label}</span>
      {children}
      {hint ? <span className="apprenant-form-field__hint">{hint}</span> : null}
    </label>
  );
}
